import React from 'react'
import './NotFound.css'
const NotFound = () => {
    return (
        <div>
            <h1>404</h1>
            <p>page not found</p>
        </div>
    );
};

export default NotFound;